import { render, staticRenderFns } from "./MarkManage.vue?vue&type=template&id=3a543e48&scoped=true"
import script from "./MarkManage.vue?vue&type=script&lang=js"
export * from "./MarkManage.vue?vue&type=script&lang=js"
import style0 from "./MarkManage.vue?vue&type=style&index=0&id=3a543e48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a543e48",
  null
  
)

export default component.exports